// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface SimulationTrackerOutput
 */
export interface SimulationTrackerOutput {
  /**
   *
   */
  results: RanaFile;
}

/**
 * Check if a given object implements the SimulationTrackerOutput interface.
 */
export function instanceOfSimulationTrackerOutput(value: object): value is SimulationTrackerOutput {
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function SimulationTrackerOutputFromJSON(json: any): SimulationTrackerOutput {
  return SimulationTrackerOutputFromJSONTyped(json, false);
}

export function SimulationTrackerOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationTrackerOutput {
  if (json == null) {
    return json;
  }
  return {
    results: RanaFileFromJSON(json["results"]),
  };
}

export function SimulationTrackerOutputToJSON(json: any): SimulationTrackerOutput {
  return SimulationTrackerOutputToJSONTyped(json, false);
}

export function SimulationTrackerOutputToJSONTyped(
  value?: SimulationTrackerOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    results: RanaFileToJSON(value["results"]),
  };
}
